import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { DataGrid as MuiDataGrid } from '@material-ui/data-grid';

import { withDefaultRenderCell } from 'helpers/dataGrid';
import { DataGridFooter } from './DataGridFooter';
import s from './styled';

const DataGrid = memo(function DataGrid(props) {
  const { total, ...rest } = props;
  const rootProps = {
    components: {
      Footer: DataGridFooter,
      ...rest?.components,
    },
    componentsProps: {
      ...rest?.componentsProps,
      footer: {
        total,
        ...rest?.componentsProps?.footer,
      },
    },
    ...rest,
  };

  rootProps.componentsProps.footer.rootProps = rootProps;
  rootProps.columns = withDefaultRenderCell(rootProps.columns);

  return <s.DataGrid {...rootProps} />;
});

DataGrid.propTypes = {
  rows: PropTypes.array,
  columns: PropTypes.array,
  total: PropTypes.object,
  pageSize: PropTypes.number,
  ...MuiDataGrid.propTypes,
};

export default DataGrid;
